export enum SearchHistoryType {
  PROJECT_TASKS = 'project-tasks'
}
